import fetch from "isomorphic-fetch";

import { handleError } from "@lib/utils/error";

import { withAccountAuthHeaders } from "./apiHelpers";
import { apiConf } from "./index";

type GetQuotationParams = { taskId: string };
export type GetQuotationResponse = {
    salary: string;
    price: string;
    assignments: Assignment[] | null;
};

type Assignment = {
    name: string;
    quantity: string;
    hourlyRate: string;
    price: string;
    rate: string;
    tags: string[] | null;
    increase: string;
};
export async function getQuotation(params: GetQuotationParams): Promise<GetQuotationResponse> {
    try {
        const resp = await fetch(
            withAccountAuthHeaders(`${apiConf.BACK_URL}/tasks/${params?.taskId}/quotation`, {
                method: `GET`,
            }),
        );

        if (resp.status >= 400) {
            handleError(await resp.json(), resp.status);
            return Promise.reject(new Error("GetQuotation"));
        }

        return resp.json();
    } catch (e) {
        handleError(e, 500);
        return Promise.reject(new Error("GetQuotation"));
    }
}
